import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from '../shared/shared.module';
import { PriceCheckComponent } from './price-check.component';

@NgModule({
  declarations: [PriceCheckComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
  ],
  exports: [PriceCheckComponent],
})
export class PriceCheckModule { }
